import { AiAutomationRouter } from './components/AiAutomationRouter/AiAutomationRouter'

export const AiAutomationRoutes = [
  {
    path: 'ai',
    Component: AiAutomationRouter,
    alias: 'aiAutomation',
    children: [
      {
        index: true,
        lazy: () => import('./aiAutomation.page'),
      },
      {
        path: 'overview',
        alias: 'aiOverview',
        lazy: () => import('./Overview/Overview'),
      },
      {
        path: 'training',
        alias: 'aiTraining',
        lazy: () => import('./Training/Training'),
      },
      {
        path: 'skills',
        alias: 'aiSkills',
        lazy: () => import('./Skills/Skills'),
      },
    ],
  },
] as const
